export const restrictedZIndexes = {
	/**
	 * 🥰
	 */
	normal: 'calc(var(--Z_INDEX_HACK, 0))',
	/**
	 * 🤨
	 */
	high: 'calc(var(--Z_INDEX_HACK, 0) + 1)',
	/**
	 * 😱
	 */
	DANGER: 'calc(var(--Z_INDEX_HACK, 0) + 2)',
} as const;
